import React from 'react';
import {
  DATA_ROUTE,
  PASSWORD_ROUTE,
  ADDRESS_ROUTE,
} from '../../../../constants/Routes';
import ProfileIcon from '../../../common/icons/profileIcon';
import PasswordIcon from '../../../common/icons/passwordIcon';
import AddressIcon from '../../../common/icons/addressIcon';

export const profileGroup = [
  {
    route: DATA_ROUTE,
    icon: <ProfileIcon size="30px" />,
    title: 'Mi perfil',
    id: 'profileSection',
  },
  {
    route: PASSWORD_ROUTE,
    icon: <PasswordIcon size="30px" />,
    title: 'Mi contraseña',
    id: 'passwordSection',
  },
  {
    route: ADDRESS_ROUTE,
    icon: <AddressIcon size="30px" />,
    title: 'Mis direcciones',
    id: 'addressesSection',
  },
];
